import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import Moment from 'react-moment';
import moment from 'moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';
import avatar from '@material-ui/core/colors/grey';

import TimecardStatus from './TimecardStatus';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  client: {
    width: "120px",
  },
  vendor: {
    flexBasis: '100px',
  },
  total: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  clientJob: {
    width: "150px",
  },
  workType: {
    width: "110px",
  },
  date: {
    width: "140px",
  },
  hours: {
    width: "60px",
  },
});

const TimecardCard = (props) => {
  const {
    classes,
    timecard,
    client,
    project,
    crew,
    workType,
    handleEdit
  } = props;

  return(
    <Card className={classes.root}>
      <div
        className={classes.content}
        onClick={() => handleEdit(timecard)}
      >
        <Avatar className={classNames(classes.avatar, classes.margin)}>
          T
        </Avatar>
        <div className={classNames(classes.margin, classes.clientJob)}>
          {client &&
            <Typography noWrap variant="subheading">
              {client.fullName}
            </Typography>
          }
          {project &&
            <Typography noWrap variant="caption">
              {project.jobCode}
            </Typography>
          }
        </div>
        <div className={classNames(classes.margin, classes.workType)}>
          {true &&
            <Typography noWrap variant="subheading">
              {workType && workType.name}
            </Typography>
          }
          {crew &&
            <Typography noWrap variant="caption">
              {crew && crew.crewFirstName}
            </Typography>
          }
        </div>
        <div className={classNames(classes.margin, classes.date)}>
          <Moment format="MMM Do, YYYY">{timecard.startDate}</Moment>
          <Typography variant="caption">
            {moment(timecard.startDate).format("h:mm a")}
          </Typography>
        </div>
        <div className={classes.divider}></div>
        <Typography className={classNames(classes.margin, classes.hours)}>
          {`${(timecard.minutesWorked/60).toFixed(1)} hrs`}
        </Typography>
        <div className={classes.divider}></div>
      </div>
      <div className={classes.margin}>
        <TimecardStatus timecard={timecard} />
      </div>
    </Card>
  );
};

const mapStateToProps = (state, props) => {
  const { timecard } = props;
  const client = timecard.clientId === undefined
    ? undefined
    : state.clientsState.find(client => client.id === timecard.clientId);
  const project = timecard.projectId === undefined
    ? undefined
    : state.projectsState.find(project => project.id === timecard.projectId);
  const crew = timecard.crewId === undefined
    ? undefined
    : state.crewState.find(crew => crew.id === timecard.crewId);
  const workType = state.workTypesState.find(workType => workType.id === timecard.workTypeId);

  return {
    client: client,
    project: project,
    crew: crew,
    vendor: undefined,
    taxCategory: undefined,
    workType,
  }
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, null)
)(TimecardCard);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/TimecardCard.jsx